import React from "react";

export interface VideoPreviewContext {
    rewindTimestamp: number;
    setRewindTimestamp(rewindTimestamp: number): void;
    currentTimestamp: number;
    setCurrentTimestamp(currentTimestamp: number): void;
    videoDuration: number;
    setVideoDuration(duration: number): void;
}

export const VideoPreviewContext = React.createContext<VideoPreviewContext>({} as VideoPreviewContext);
